"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspaceReducerBase = void 0;
var tslib_1 = require("tslib");
var actions_1 = require("../../constants/actions");
var createGenericReducer_1 = require("./createGenericReducer");
var extend = function (state, action) {
    var _a;
    if (!action || !state) {
        return state || null;
    }
    if (action.type === actions_1.GET_WORKSPACE_LOGO_URL_SUCCESS) {
        return tslib_1.__assign(tslib_1.__assign({}, state), (_a = {}, _a[action.requestValues.workspaceId] = tslib_1.__assign(tslib_1.__assign({}, state[action.requestValues.workspaceId]), { logoUrl: action.successValues.logoUrl }), _a));
    }
    return state || null;
};
var patchRequestAction = 'PATCH_WORKSPACES_REQUEST';
var getSuccessAction = 'GET_WORKSPACES_SUCCESS';
var deleteRequestAction = 'DELETE_WORKSPACES_REQUEST';
exports.workspaceReducerBase = (0, createGenericReducer_1.createGenericReducer)({
    getSuccessAction: getSuccessAction,
    patchRequestAction: patchRequestAction,
    deleteRequestAction: deleteRequestAction,
    extend: extend,
});
